<template>
  <router-view/>
</template>

<style lang="scss" >
* {
  margin: 0;
  padding: 0;
}
.bg {
  background: #ffffff;
  border-radius: 3px;
  box-shadow: 1px 1px 5px #aaa;
  box-sizing: border-box;
  padding: 20px;
}
</style>
